import React from 'react';
import { withPrefix, Link } from 'gatsby';

import classes from './model-header-card.module.css';

const ModelHeaderCard = props => {
  let makeInfo = {
    ...props.data,
    imagePath: `logo-${props.data.slug}.jpg`,
    newImagePath: `make_${props.data.slug}@5x.png`
  };

  return (
    <div className={classes.ModelHeaderCard}>
      <div>
        <div className={classes.ImageContainer}>
          <img
            src={withPrefix(`/new-logos/${makeInfo.newImagePath}`)}
            alt={`${makeInfo.make} Logo`}
          />
        </div>
        <div className={classes.InfoContainer}>
          <h1 style={{ fontSize: 22, marginBottom: 0 }}>{makeInfo.make}</h1>
          <p className={`${classes.agent} text-color-urbangrey60`}>
            {makeInfo.agent}
          </p>
          {makeInfo.showrooms.map(showroom => {
            return (
              <div className={`${classes.Showroom}`} key={showroom.id}>
                <p className={classes.street}>
                  {showroom.street}, SG {showroom.postcode}
                </p>
                <a
                  href={`tel:+65${showroom.tel}`}
                  className={`${classes.tel} text-color-skyteal80`}
                >
                  {showroom.tel}
                </a>
              </div>
            );
          })}
        </div>
      </div>

      <div
        className={`text-color-urbangrey60`}
        style={{
          fontSize: 14
        }}
      >
        <div>
          <Link
            to={`${makeInfo.slug}-image`}
            state={{ imageUrl: makeInfo.link }}
          >
            <div
              style={{
                backgroundImage: `url(${makeInfo.links[0].link})`,
                backgroundSize: 'cover',
                height: 130,
                borderRadius: 8,
                overflow: 'hidden',
                boxShadow: '0px 0px 4px 4px rgba(240,241,241,1)',
                margin: 4
                // border: '1px solid lightgray'
              }}
            />
          </Link>
        </div>
        <div style={{ textAlign: 'center', marginTop: 8 }}>
          {' '}
          As of {makeInfo.linkDate}
        </div>
      </div>
    </div>
  );
};

export default ModelHeaderCard;
